import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { t } from 'translation'

import AuthErrorBox from 'components/Auth/AuthErrorBox'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'

const loginSchema = Yup.object().shape({
  email: Yup.string().email('INVALID_EMAIL').required('EMAIL_IS_REQUIRED'),
})
const AuthResetPasswordEmailForm = ({
  alreadyHaveCodeHandler,
  submitFormHandler,
  apiResponseError,
  resetApiResponseError,
  loading,
  goBackHandler,
  needButton,
}) => (
  <Formik
    initialValues={{ email: '' }}
    validationSchema={loginSchema}
    onSubmit={submitFormHandler}
  >
    {({ errors, touched, setFieldTouched, values, submitForm }) => (
      <Form className="tab_content login_mod active_tab">
        <h2 className="section_title v3_mod center_level_mod color_mod offset_v3_mod">
          {t('auth.ENTER_EMAIL_TO_RESET')}
        </h2>
        <AuthErrorBox
          formFields={['email']}
          formTouched={touched}
          formErrors={errors}
          apiResponseError={apiResponseError}
          resetApiResponseError={resetApiResponseError}
        />
        <div className="form_controller login_mod">
          <dl className="form_cell form_cell_v1_mod">
            <dt className="form_cell_title form_v3_mod">
              <label htmlFor="login_email">{t('auth.EMAIL')}</label>
            </dt>
            <dd className="form_field_wrap form_v3_mod">
              <Field
                className="form_field v4_mod"
                type="email"
                name="email"
                id="login_email"
                placeholder=""
                disabled={loading}
              />
            </dd>
          </dl>
        </div>
        <div className="login_bottom">
          <LoadingButton
            className="btn_base_v1"
            type="submit"
            onClick={submitForm}
            isLoading={loading}
          >
            {t('auth.RESET_PASSWORD')}
          </LoadingButton>
        </div>
        {needButton && (
          <div className="login_descr">
            <button
              className="login_descr_link"
              disabled={loading}
              onClick={() => {
                setFieldTouched('email')
                if (!errors.email && values.email) alreadyHaveCodeHandler(values.email)
              }}
            >
              {t('auth.ALREADY_HAVE_CODE')}
            </button>
            <button
              className="login_descr_link"
              onClick={goBackHandler}
              disabled={loading}
            >
              {t('auth.GO_BACK')}
            </button>
          </div>
        )}
      </Form>
    )}
  </Formik>
)

const mapStateToProps = ({ auth: { loading } }) => ({ loading })

export default connect(mapStateToProps)(AuthResetPasswordEmailForm)

AuthResetPasswordEmailForm.propTypes = {
  alreadyHaveCodeHandler: PropTypes.func.isRequired,
  submitFormHandler: PropTypes.func.isRequired,
  apiResponseError: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  resetApiResponseError: PropTypes.func.isRequired,
  goBackHandler: PropTypes.func.isRequired,
}
